import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/contract-actions';
import { ContractActions } from '../constants';
import { IContract, IContractDoc } from 'src/types/contract';

export interface ContractState {
    inProgress: boolean;
    inProgressCSV: boolean;
    authCode: string;
    error: string;
    totals: any;
    data: Paginated<IContract>;
    dataDocs: Paginated<IContractDoc>;
    current: IContract | null;
    currentFiles: any | null;
    signers: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    totals: {},
    inProgressCSV: false,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    dataDocs: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    current: null,
    currentFiles: null,
    signers: null,
};

export function contracts(state: ContractState = initialState, action: Actions | any): ContractState {
    switch (action.type) {
        case requestType(ContractActions.CREATE_CONTRACT):
            return { ...state, error: '', inProgress: true };
        case successType(ContractActions.CREATE_CONTRACT):
            return { ...state, inProgress: false };
        case failureType(ContractActions.CREATE_CONTRACT):
            return { ...state, error: action.error, inProgress: false };

        case requestType(ContractActions.PERSIST_CONTRACT):
            return { ...state, error: '', inProgress: true };
        case successType(ContractActions.PERSIST_CONTRACT):
            return { ...state, current: action.payload, inProgress: false };
        case failureType(ContractActions.PERSIST_CONTRACT):
            return { ...state, error: action.error, inProgress: false };

        case requestType(ContractActions.FETCH_CONTRACTS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],

                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ContractActions.FETCH_CONTRACTS):
            return {
                ...state,
                data: {
                    ...action.payload,
                    list: Object.keys(state.totals).length
                        ? [state.totals, ...action.payload.list]
                        : action.payload.list,
                    inProgress: false,
                },
                inProgress: false,
            };
        case failureType(ContractActions.FETCH_CONTRACTS):
            return {
                ...state,
                data: { ...state.data, inProgress: false },
                error: action.error,
                inProgress: false,
            };
        case successType(ContractActions.FETCH_CONTRACTS_TOTALS):
            if (action.total) {
                return {
                    ...state,
                    totals: action.payload,
                    data: {
                        ...state.data,
                        ...action.payload,
                        list: Object.keys(action.payload).length
                            ? [action.payload, ...state.data?.list]
                            : state.data?.list,
                        inProgress: false,
                    },
                    inProgress: false,
                };
            }
            return state;
        case failureType(ContractActions.FETCH_CONTRACTS_TOTALS):
            return { ...state, totals: {}, error: action.error, inProgress: false };
        case requestType(ContractActions.FETCH_CONTRACTS_TOTALS):
            return { ...state, inProgress: true, totals: {}, error: '' };

        case requestType(ContractActions.FETCH_CONTRACT):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(ContractActions.FETCH_CONTRACT):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(ContractActions.FETCH_CONTRACT):
            return { ...state, inProgress: false, error: action.error };

        case requestType(ContractActions.DELETE_CONTRACT):
            return { ...state, error: '', inProgress: true };
        case successType(ContractActions.DELETE_CONTRACT):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IContract) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(ContractActions.DELETE_CONTRACT):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };


        case requestType(ContractActions.SEND_CONTRACT_TO_DOCUSIGN):
            return { ...state, error: '', inProgress: true };
        case successType(ContractActions.SEND_CONTRACT_TO_DOCUSIGN):
            return { ...state, inProgress: false };
        case failureType(ContractActions.SEND_CONTRACT_TO_DOCUSIGN):
            return { ...state, error: action.error, inProgress: false };

        case requestType(ContractActions.REMIND_CONTRACT_TO_DOCUSIGN):
            return { ...state, error: '', inProgress: true };
        case successType(ContractActions.REMIND_CONTRACT_TO_DOCUSIGN):
            return { ...state, inProgress: false };
        case failureType(ContractActions.REMIND_CONTRACT_TO_DOCUSIGN):
            return { ...state, error: action.error, inProgress: false };

        case requestType(ContractActions.FETCH_CONTRACT_DOCS):
            return {
                ...state,
                dataDocs: {
                    ...state.dataDocs,
                    list: [],
                    meta: state.dataDocs?.meta?.updatedAt
                        ? state.dataDocs?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ContractActions.FETCH_CONTRACT_DOCS):
            return { ...state, dataDocs: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(ContractActions.FETCH_CONTRACT_DOCS):
            return {
                ...state,
                dataDocs: { ...state.dataDocs, inProgress: false },
                error: action.error,
                inProgress: false,
            };

        default:
            return state;
    }
}
